import React from 'react';
export const EventHeaderSkeleton = () => {
  return (
    <div className='w-full flex bg-surface-primary pt-10 pb-4 md:pb-6 animate-pulse'>
      <div className='flex flex-col justify-between w-full max-w-7xl mx-auto'>
        {/* Back arrow */}
        <div className='pl-3.5 mb-6'>
          <div className='w-5 h-5 bg-tertiary rounded-sm'></div>
        </div>
        {/* Event info row */}
        <div className='flex gap-3 md:gap-4 items-start mb-6 md:mb-10 px-4'>
          <div className='w-16 h-16 relative shrink-0 bg-tertiary rounded-lg'></div>
          <div className='flex flex-col gap-2'>
            <div className='h-6 bg-tertiary rounded-sm w-48 md:w-64'></div>
            <div className='flex flex-wrap gap-x-3 gap-y-1'>
              <div className='h-4 bg-tertiary rounded-sm w-24'></div>
              <div className='h-4 bg-tertiary rounded-sm w-32'></div>
              <div className='h-4 bg-tertiary rounded-sm w-36'></div>
            </div>
          </div>
        </div>
        {/* Tabs */}
        <div className='flex gap-2 pl-4'>
          <div className='h-10 bg-tertiary w-16 rounded-3xl'></div>
          <div className='h-10 bg-tertiary w-20 rounded-3xl'></div>
          <div className='h-10 bg-tertiary w-24 rounded-3xl'></div>
        </div>
      </div>
    </div>
  );
};
